import { render, staticRenderFns } from "./CalculationResult.vue?vue&type=template&id=397d65eb&"
import script from "./CalculationResult.vue?vue&type=script&lang=ts&"
export * from "./CalculationResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports